import Vue from 'vue'
import Vuex from 'vuex'
import { formatCoin4 } from '@/tools'

Vue.use(Vuex)

const snakeToCamel = (str) =>
  str.replace(/([-_]\w)/g, (g) => g[1].toUpperCase())

// const freezeMonthAll = [720,715,705,690,670,645,615,580,540,495,445,445,360,350,340,330,320,310,300,290,280,270,260,250,180,175,170,165,160,150,140,130,120,110,100,90]
//   .map((p, i) => ({ code: Date.UTC(2021,11 + i,1), index: p}))
//   .filter(i => i.code >= Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), 1))

export default new Vuex.Store({
  state: {
    package: {},
    packageAll: [],

    rate: 0,
    freezing: 0,
    budget: 0,
    total: 0,

    startCourse: 5000,
    startCourseAll: [
      { code: 5000, label: '5 000 EUR' },
      { code: 10000, label: '10 000 EUR' },
      { code: 15000, label: '15 000 EUR' },
      { code: 20000, label: '20 000 EUR' },
      { code: 25000, label: '25 000 EUR' },
      { code: 30000, label: '30 000 EUR' },
      { code: 35000, label: '35 000 EUR' },
      { code: 40000, label: '40 000 EUR' },
      { code: 50000, label: '50 000 EUR' },
      { code: 60000, label: '60 000 EUR' },
      { code: 70000, label: '70 000 EUR' },
      { code: 80000, label: '80 000 EUR' },
      { code: 90000, label: '90 000 EUR' },
      { code: 100000, label: '100 000 EUR' },
      { code: 120000, label: '120 000 EUR' },
      { code: 150000, label: '150 000 EUR' },
    ],

    endCourse: 5000,
    // endCourseAll: [
    //   // { code: 5000, label: '5 000 EUR' },
    //   // { code: 10000, label: '10 000 EUR' },
    //   // { code: 15000, label: '15 000 EUR' },
    //   // { code: 20000, label: '20 000 EUR' },
    //   // { code: 25000, label: '25 000 EUR' },
    //   { code: 30000, label: '30 000 EUR' },
    //   { code: 35000, label: '35 000 EUR' },
    //   { code: 40000, label: '40 000 EUR' },
    //   { code: 45000, label: '45 000 EUR' },
    //   { code: 50000, label: '50 000 EUR' },
    //   { code: 60000, label: '60 000 EUR' },
    //   { code: 70000, label: '70 000 EUR' },
    //   { code: 80000, label: '80 000 EUR' },
    //   { code: 90000, label: '90 000 EUR' },
    //   { code: 100000, label: '100 000 EUR' },
    //   { code: 110000, label: '110 000 EUR' },
    //   { code: 120000, label: '120 000 EUR' },
    //   { code: 130000, label: '130 000 EUR' },
    //   { code: 140000, label: '140 000 EUR' },
    //   { code: 150000, label: '150 000 EUR' },
    //   { code: 175000, label: '175 000 EUR' },
    //   { code: 200000, label: '200 000 EUR' },
    // ],

    freezeMonth: 1,
    freezeMonthAll: [
      // { code: 1, label: '1-3', month: 1657832400000, index: 6.115 },
      // { code: 2, label: '4-6', month: 1657832400000, index: 6.08 },
      // { code: 3, label: '7-9', month: 1657832400000, index: 6.045 },
      // { code: 4, label: '10-12', month: 1657832400000, index: 6.01 },
      // { code: 5, label: '13-15', month: 1657832400000, index: 5.975 },
      // { code: 6, label: '16-18', month: 1657832400000, index: 5.94 },
      // { code: 7, label: '19-21', month: 1657832400000, index: 5.905 },
      // { code: 8, label: '22-24', month: 1657832400000, index: 5.87 },
      // { code: 9, label: '25-27', month: 1657832400000, index: 5.835 },
      // { code: 10, label: '28-31', month: 1657832400000, index: 5.8 },
      // { code: 11, label: '1-3', month: 1660510800000, index: 5.76 },
      // { code: 12, label: '4-6', month: 1660510800000, index: 5.72 },
      // { code: 13, label: '7-9', month: 1660510800000, index: 5.68 },
      // { code: 14, label: '10-12', month: 1660510800000, index: 5.64 },
      // { code: 15, label: '13-15', month: 1660510800000, index: 5.6 },
      // { code: 16, label: '16-18', month: 1660510800000, index: 5.56 },
      // { code: 17, label: '19-21', month: 1660510800000, index: 5.52 },
      // { code: 18, label: '22-24', month: 1660510800000, index: 5.48 },
      // { code: 19, label: '25-27', month: 1660510800000, index: 5.44 },
      // { code: 20, label: '28-31', month: 1660510800000, index: 5.4 },
    ],

    /** config */
    config: {
      domainUltimaFarm: '',
      domainUltimaRest: '',
    }
  },
  mutations: {
    setRate(state, value) {
      state.rate = value
    },

    setBudget(state, value) {
      const findPacks = state.packageAll.filter((pack) => {
        const maxLoad = formatCoin4(pack.license / state.startCourse) * 0.5
        return (pack.price + maxLoad * state.rate) < value
      })
      if (findPacks.length) {
        state.package = findPacks.reverse()[0]
      } else {
        state.package = state.packageAll[0]
      }
      const maxLoad = state.package.license / state.startCourse
      state.freezing = formatCoin4(
        (value - state.package.price) / state.rate,
        maxLoad
      )
      state.budget = value
    },

    setPackage(state, value) {
      state.package = value
    },
    setPackageAll(state, value) {
      state.packageAll = value
      state.package = value[0]
    },

    // StartCourse
    setStartCourse(state, value) {
      state.startCourse = value
    },

    // EndCourse
    setEndCourse(state, value) {
      state.endCourse = value
    },

    // AvailableMaxLoad
    setFreezeMonth(state, value) {
      state.freezeMonth = value
    },
    setFreezeMonthAll(state, value) {
      state.freezeMonthAll = value
    },

    setFreezing(state, value) {
      state.freezing = value
      //state.total = Number.parseFloat((state.package.price + state.rate * state.freezing).toFixed(2))
    },

    /** config */
    setConfig(state, value) {
      Object.keys(value).forEach((key) => {
        state.config[snakeToCamel(key)] = value[key]
      })
    },
  },
  getters: {
    license: state => state.package.license,
    licenseAll: state => state.packageAll.map(pack => ({
      code: pack.license,
      label: pack.licenseName,
    })),
    availableMaxLoad: state => formatCoin4(state.package.license / state.startCourse),
    availableMaxLoadAll: state => state.packageAll.map(pack => ({
      code: formatCoin4(pack.license / state.startCourse),
      label: formatCoin4(pack.license / state.startCourse) + ' ULTIMA',
    })),
    mintingCalendar: state => {
      const freezeMonth = state.freezeMonthAll.find(i => i.code === state.freezeMonth).index
      const year = state.freezing * freezeMonth // * 0.6
      const month = year / 12
      const day = year / 365
      return {
        year: { ULTIMA: year.toFixed(6), EUR: (year * state.endCourse).toFixed(2) },
        month: { ULTIMA: month.toFixed(6), EUR: (month * state.endCourse).toFixed(2) },
        day: { ULTIMA: day.toFixed(6), EUR: (day * state.endCourse).toFixed(2) },
      }
    },
    /** config */
    getConfig: state => state.config
  }
})
